import { RotateCcw, Search } from "lucide-react";

import { Button } from "../ui/button";
import { Input } from "../ui/input";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "../ui/select";

export const getProductionCreatedDate = (order) => {
  const rawDate = order.created_at || order.createdAt || "";
  return String(rawDate).slice(0, 10);
};

export const filterProductionOrders = ({
  orders,
  search,
  status,
  dateFrom,
  dateTo,
}) => {
  const query = search.trim().toLocaleLowerCase();

  return orders.filter((order) => {
    const createdDate = getProductionCreatedDate(order);
    const searchable = [
      order.number,
      order.partner_name,
      order.product_name,
      ...(order.product_names || []),
    ].join(" ").toLocaleLowerCase();
    const matchesSearch = !query || searchable.includes(query);
    const matchesStatus = status === "all" || order.status === status;
    const matchesFrom = !dateFrom || (createdDate && createdDate >= dateFrom);
    const matchesTo = !dateTo || (createdDate && createdDate <= dateTo);

    return matchesSearch && matchesStatus && matchesFrom && matchesTo;
  });
};

export const ProductionTableControls = ({
  dateFrom,
  dateTo,
  onDateFromChange,
  onDateToChange,
  onReset,
  onSearchChange,
  onStatusChange,
  resultCount,
  search,
  status,
  statusOptions,
  testIdPrefix,
  totalCount,
}) => (
  <div className="mb-4 space-y-2" data-testid={`${testIdPrefix}-datatable-controls`}>
    <div className="grid gap-2 sm:grid-cols-2 xl:grid-cols-[minmax(220px,1.4fr)_180px_150px_150px_auto]">
      <div className="relative">
        <Search className="absolute left-3 top-2.5 h-4 w-4 text-wmuted" />
        <Input
          aria-label="Cari order produksi"
          className="pl-9"
          data-testid={`${testIdPrefix}-search-input`}
          onChange={(event) => onSearchChange(event.target.value)}
          placeholder="Cari nomor, konveksi, atau produk"
          value={search}
        />
      </div>
      <Select onValueChange={onStatusChange} value={status}>
        <SelectTrigger data-testid={`${testIdPrefix}-status-filter`}>
          <SelectValue placeholder="Semua status" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="all">Semua status</SelectItem>
          {statusOptions.map((option) => (
            <SelectItem key={option} value={option}>{option}</SelectItem>
          ))}
        </SelectContent>
      </Select>
      <label className="space-y-1 text-xs text-wmuted">
        <span>Created At dari</span>
        <Input
          aria-label="Tanggal dibuat mulai"
          data-testid={`${testIdPrefix}-date-from`}
          onChange={(event) => onDateFromChange(event.target.value)}
          type="date"
          value={dateFrom}
        />
      </label>
      <label className="space-y-1 text-xs text-wmuted">
        <span>Created At sampai</span>
        <Input
          aria-label="Tanggal dibuat sampai"
          data-testid={`${testIdPrefix}-date-to`}
          onChange={(event) => onDateToChange(event.target.value)}
          type="date"
          value={dateTo}
        />
      </label>
      <Button
        aria-label="Reset filter"
        data-testid={`${testIdPrefix}-reset-filter`}
        onClick={onReset}
        size="icon"
        title="Reset filter"
        variant="outline"
      >
        <RotateCcw className="h-4 w-4" />
      </Button>
    </div>
    <p className="text-xs text-wmuted" data-testid={`${testIdPrefix}-result-count`}>
      Menampilkan {resultCount} dari {totalCount} order
    </p>
  </div>
);

export const ProductionTablePagination = ({
  onPageChange,
  page,
  testIdPrefix,
  totalPages,
}) => (
  <div className="mt-4 flex items-center justify-between gap-3">
    <p className="text-xs text-wmuted" data-testid={`${testIdPrefix}-pagination-info`}>
      Halaman {page} dari {totalPages}
    </p>
    <div className="flex items-center gap-2">
      <Button
        data-testid={`${testIdPrefix}-previous-page`}
        disabled={page === 1}
        onClick={() => onPageChange(page - 1)}
        size="sm"
        variant="outline"
      >
        Sebelumnya
      </Button>
      <Button
        data-testid={`${testIdPrefix}-next-page`}
        disabled={page === totalPages}
        onClick={() => onPageChange(page + 1)}
        size="sm"
        variant="outline"
      >
        Berikutnya
      </Button>
    </div>
  </div>
);